

<template>
    <div class="flex flex-col gap-8">
        <vx-card class="bg-primary text-white">
            <h1 class="text-white"> Nueva actualización proximamente! </h1>
            <p class="mt-2">
                Estamos trabajando en una nueva actualización que estamos seguros te encantará.
                Estará disponible en las próximas semanas, durante el mes de mayo. 
                Mantente atento a más detalles.
            </p>
        </vx-card>
    </div>
</template>
<script>
export default {
  name: 'ComingSoon'
}
</script>